import(/* webpackMode: "eager" */ "/vercel/path0/src/app/providers/page.tsx");
